import { render, staticRenderFns } from "./SearchbarComponent.vue?vue&type=template&id=f0adf63e"
import script from "./SearchbarComponent.vue?vue&type=script&lang=js"
export * from "./SearchbarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports